
export function getStorage(k, type = 'local') {
    const mgr = type === 'local' ? localStorage : sessionStorage;
    let obj = JSON.parse(mgr.getItem(k) || '{}');
    return {
        get(p) {
            return p ? obj[p] : obj;
        },
        set(map) {
            Object.assign(obj, map);
            mgr.setItem(k, JSON.stringify(obj));
            return this;
        },
        clear() {
            obj = {};
            mgr.removeItem(k);
            return this;
        },
    };
}


// WEBPACK FOOTER //
// ./src/utils/storage.js